/* One word in a heading, cycling.
 *
 * The words are all in the DOM already, stacked in a single grid cell. This
 * file moves the `is-on` class and sizes the slot to the word currently in
 * it, so the sentence closes up around a short word instead of holding a gap
 * the width of the longest one.
 *
 * It does nothing when the visitor has asked for reduced motion, and nothing
 * while the heading is off screen.
 */
(function () {
  var DWELL = 3000;

  function setup(el) {
    var words = Array.prototype.slice.call(el.querySelectorAll('.ndrot__w'));
    if (words.length < 2) return null;

    var i = 0;
    var timer = null;
    var widths = [];

    // Each word is `justify-self: start`, so it sits at its own width inside
    // the shared cell and can be measured where it stands.
    // The heading it lives in is reserved at the tallest the word list can
    // make it.
    //
    // The slot's width takes part in line layout, so a short word can let
    // the whole heading fit on one line where a long one needs two. On a
    // phone "recruiters" fitted and "consultants" did not, and the section
    // jumped 25px every time the cycle came round to it.
    //
    // Each candidate width is applied in turn and the host measured, so
    // the reservation is exactly what the longest word needs and not a
    // guess at a line count.
    function reserve() {
      var host = el.closest('h1, h2, h3, p') || el.parentElement;
      if (!host) return;
      var restore = el.style.getPropertyValue('--ndrot-w');
      host.style.minHeight = '';
      var tallest = 0;
      widths.forEach(function (px) {
        el.style.setProperty('--ndrot-w', px + 'px');
        tallest = Math.max(tallest, host.getBoundingClientRect().height);
      });
      host.style.minHeight = tallest + 'px';
      if (restore) el.style.setProperty('--ndrot-w', restore);
    }

    function measure() {
      widths = words.map(function (w) {
        return w.getBoundingClientRect().width;
      });
      reserve();
      fit();
    }

    function fit() {
      if (widths[i]) el.style.setProperty('--ndrot-w', widths[i] + 'px');
    }

    // Drawn once on load, whether or not the cycling has started, so the
    // first word is marked the same way as every one after it.
    el.classList.add('is-drawn');

    // The rule under the word is redrawn on each change: dropped to zero,
    // forced to lay out at zero, then released. Without the reflow the
    // browser coalesces both writes into one frame and nothing animates.
    function redraw() {
      el.classList.remove('is-drawn');
      void el.offsetWidth;
      el.classList.add('is-drawn');
    }

    function step() {
      var prev = words[i];
      prev.classList.remove('is-on');
      prev.classList.add('is-out');
      setTimeout(function () { prev.classList.remove('is-out'); }, 600);
      i = (i + 1) % words.length;
      words[i].classList.add('is-on');
      fit();
      redraw();
    }

    // Measured after the webfont lands, or the slot is sized to the fallback
    // face and every word is a few pixels wrong.
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(measure);
    } else {
      measure();
    }

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(measure, 200);
    });

    // Only run while the heading is on screen. A timer ticking against a
    // section three screens down is pure battery cost.
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting && !timer) {
          timer = setInterval(step, DWELL);
        } else if (!entry.isIntersecting && timer) {
          clearInterval(timer);
          timer = null;
        }
      });
    }, { threshold: 0.2 }).observe(el);
  }

  function init() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('[data-ndrot]').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
